var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-btn-box"},[_c('van-button',{staticClass:"go-back",attrs:{"icon":"arrow-left"},on:{"click":_vm.goBackPage}}),_c('van-button',{staticClass:"go-next",attrs:{"icon":"arrow"},on:{"click":_vm.goNextPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }